<template>
  <div>
    <div class="section">
      <div class="container">
        <div class="section__content center login">
          <form v-on:submit.prevent="login">
            <h1 class="std__subtile">{{$t("login_title")}}</h1>
            <h2 class="std__subtile md">
              {{$t("confirmation")}}
            </h2>
            <div class="mobiForElm">
              <input
                type="tel"
                class="mobiForElm__input"
                v-model="msisdn"
                maxlength="14"
                placeholder
              />
            </div>
            <div class="btnContainer">
              <button type="submit" class="mobiBtn">{{$t("submit")}}</button>
            </div>
            <div
              v-if="showStatusAlert"
              class="alert alert-danger col-md-3"
              role="alert"
            >
              <span v-if="lang_cutehub === 'english'">{{ status }}</span>
              <span v-if="lang_cutehub !== 'english'">{{ statusTran }}</span>
              <!-- <span v-if="lang_cutehub === 'english'">{{ status }}</span>
              <span v-if="lang_cutehub === 'arabic'">{{ statusAR }}</span>
              <span v-if="lang_cutehub === 'greek'">{{ statusGR }}</span>
              <span v-if="lang_cutehub === 'malay' || lang_cutehub === 'indonesian'">{{ statusMYID }}</span> -->
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
            <div
              v-if="showMsisdnAlert"
              class="alert alert-danger col-md-5"
              role="alert"
            >
              {{$t("valid_number")}}
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import cutehub from "../../../router/cutehub";
import country_list from "../../../locales/country_list.json";
import EventBus from "../../EventBus.vue";
import { mapActions, mapGetters } from "vuex";

const proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

export default {
  data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  created(){
    this.getPrefix(this.country_cutehub)
  },
  computed: mapGetters(["lang_cutehub", "gcid_cutehub" ,"country_cutehub"]),
  methods: {
    getPrefix(country){
      for (let [key, value] of Object.entries(country_list)) {
        if(country == key){
          this.msisdn = '+'+value.prefix;
        }
      }
    },
    close(){
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login() {
      let regex = /^\d{9,}$/;
      let a = this.msisdn;
      this.msisdn = a.replace("+","");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          let gcid = "";
          if(this.gcid_cutehub != ""){
            gcid = this.gcid_cutehub
          }else{
            //dummy gcid
            gcid = "264";
          }
          
          let data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          const login = {
            url: `${proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=${data.msisdn}&gcid=${data.gcid}&verbose=${data.verbose}`),
            method: "POST"
          };
          this.$axios(login)
            .then(res => {
              var response = JSON.parse(res.data.contents);
              if (response.status == "active") {
                localStorage.setItem("userToken_cutehub", response.token);
                localStorage.setItem("userProfile_cutehub", res.data.contents)
                this.msisdn = "";
                // this.emitMethod();
                this.login_cutehub("loggedin");
                cutehub.push({ name: "Main" }).catch(err => {});
                location.reload();
              } else if (response.status == "inactive") {
                this.showStatusAlert = true;
                this.showMsisdnAlert = false;
                let status = response.status.replace( response.status.toUpperCase());
                this.status = status;

                for (let [key, value] of Object.entries(country_list)) {
                  if(this.country_cutehub == key){
                    let status_lang = require(`../../../locales/cutehub/${value.language}.json`);
                    this.statusTran = status_lang.status;
                  }
                }
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      }
    },
    ...mapActions(["login_cutehub"])
    // emitMethod() {

    // }
  }
};
</script>

<style lang="scss" scoped>
.section__content.login {
  max-width: 780px;
  width: 100%;
  margin: 0 auto;
  color: #fff;
  text-align: center;
}
input.mobiForElm__input {
  direction: ltr;
}
.alert {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/cutehub/Login.vue